<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M10.0003 10.8332C10.5755 10.8332 11.0419 10.3669 11.0419 9.79162C11.0419 9.21635 10.5755 8.75 10.0003 8.75C9.42501 8.75 8.95866 9.21635 8.95866 9.79162C8.95866 10.3669 9.42501 10.8332 10.0003 10.8332Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M17.2913 10.8332C17.8666 10.8332 18.3329 10.3669 18.3329 9.79162C18.3329 9.21635 17.8666 8.75 17.2913 8.75C16.7161 8.75 16.2497 9.21635 16.2497 9.79162C16.2497 10.3669 16.7161 10.8332 17.2913 10.8332Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M2.70846 10.8332C3.28373 10.8332 3.75008 10.3669 3.75008 9.79162C3.75008 9.21635 3.28373 8.75 2.70846 8.75C2.13319 8.75 1.66685 9.21635 1.66685 9.79162C1.66685 10.3669 2.13319 10.8332 2.70846 10.8332Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconEllipsisHorizontal',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
